/* ********************************************************* *
 * Merged Nodes - Unions of node-html-parser and common DOM
 * ********************************************************* */

type NodeBase = { preserve?: boolean }

export type HtmlNode = (Node) & NodeBase
export type ElementNode = (HTMLElement) & NodeBase
export type TextNode = Text & NodeBase
export type CommentNode = Comment & NodeBase;

export const isTextNode = (node: HtmlNode): node is TextNode => node.nodeType === Node.TEXT_NODE;
export const isCommentNode = (node: HtmlNode): node is CommentNode => node.nodeType === Node.COMMENT_NODE;
export const isElementNode = (node: HtmlNode): node is ElementNode => node.nodeType === Node.ELEMENT_NODE;